import {
  Button,
  Checkbox,
  Heading,
  Link,
  Modal,
  ModalContent,
  ModalOverlay,
  Text,
  VStack,
} from "@chakra-ui/react";
import { useState } from "react";
import {
  BG_OVERLAY,
  COLOR_ERROR,
  METRIPORT_PRIMARY,
  METRIPORT_PRIMARY_HOVER,
  TEXT_SECONDARY,
} from "../../../shared/constants";

type TermsOfServiceModalProps = {
  isOpen: boolean;
  isAccepting: boolean;
  onAccept: () => void;
};

export function TermsOfServiceModal({ isOpen, isAccepting, onAccept }: TermsOfServiceModalProps) {
  const [isChecked, setIsChecked] = useState(false);

  return (
    <Modal
      isOpen={isOpen}
      onClose={() => {
        return undefined;
      }}
      closeOnOverlayClick={false}
      closeOnEsc={false}
      isCentered
      size="md"
    >
      <ModalOverlay bg={BG_OVERLAY} />
      <ModalContent p={8} borderRadius="xl">
        <VStack gap={6} align="stretch">
          <Heading size="lg" textAlign="center">
            Terms of Service
          </Heading>

          <Checkbox
            isChecked={isChecked}
            onChange={e => setIsChecked(e.target.checked)}
            colorScheme="blue"
            size="lg"
          >
            <Text fontSize="md" color={TEXT_SECONDARY}>
              I agree to the Metriport{" "}
              <Link
                href="https://www.metriport.com/terms-of-service"
                color={METRIPORT_PRIMARY}
                isExternal
                textDecoration="underline"
              >
                Terms of Service
              </Link>
              .
              <Text as="span" color={COLOR_ERROR}>
                *
              </Text>
            </Text>
          </Checkbox>

          <Button
            bg={METRIPORT_PRIMARY}
            _hover={{ bg: METRIPORT_PRIMARY_HOVER }}
            color="white"
            size="md"
            width="full"
            onClick={onAccept}
            isLoading={isAccepting}
            isDisabled={!isChecked}
            loadingText="Accepting..."
          >
            Proceed
          </Button>
        </VStack>
      </ModalContent>
    </Modal>
  );
}
